// extracted by mini-css-extract-plugin
export default {"videoSectionDescription":"VideoSection_videoSectionDescription__BoS8e","videoPlayer":"VideoSection_videoPlayer__y3zMI"};